export const getBaseDomain = (hostname: string): string => {
    const trimmed = hostname.trim();
    if (!trimmed) return hostname;
    if (trimmed === 'localhost') return trimmed;
    if (/^\d{1,3}(\.\d{1,3}){3}$/.test(trimmed) || trimmed.includes(':')) {
        return trimmed;
    }
    const parts = trimmed.split('.').filter(Boolean);
    if (parts.length <= 2) return trimmed;
    const envMarker = parts[parts.length - 3];
    if (envMarker && ['setup', 'staging', 'dev'].includes(envMarker)) {
        return parts.slice(-3).join('.');
    }
    return parts.slice(-2).join('.');
};
